import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { GrauInovacao } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class GrauInovacaoService {

  private readonly service = '/sepin-backend/rest/graus-inovacao';

  private abrangenciaObservable: Observable<GrauInovacao[]>;
  private desenvolvimentoObservable: Observable<GrauInovacao[]>;

  constructor(private readonly http: McticHttpClient) {
  }

  obterTodos() {
    return this.http.get<GrauInovacao[]>(this.service);
  }

  obterGrausInovacaoDesenvolvimento() {
    if (!this.desenvolvimentoObservable) {
      const queryParams = new McticHttpParams().setNumber('tipo', 1);

      this.desenvolvimentoObservable = this.http.get<GrauInovacao[]>(this.service, {params: queryParams.toHttpParams()}).pipe(
        publishReplay(1), refCount()
      );
    }

    return this.desenvolvimentoObservable;
  }

  obterGrausInovacaoAbrangencia() {
    if (!this.abrangenciaObservable) {
      const queryParams = new McticHttpParams().setNumber('tipo', 0);

      this.abrangenciaObservable = this.http.get<GrauInovacao[]>(this.service, {params: queryParams.toHttpParams()}).pipe(
        publishReplay(1), refCount()
      );
    }

    return this.abrangenciaObservable;
  }

}
